import { useState } from 'react';
import {
  StatusMultiSelect,
  TableActionMenu,
  UuidFilterInput,
  type TableActionItem,
} from '@/components/shared';
import { INTERVIEW_QUALITY_LABELS, type InterviewQualityFilter } from '@/lib/interview-quality';

const QUALITY_STATUS_OPTIONS = Object.entries(INTERVIEW_QUALITY_LABELS).map(([value, label]) => ({
  value: value as InterviewQualityFilter,
  label,
}));

export interface ProjectInterviewsFiltersProps {
  qualityStatuses: InterviewQualityFilter[];
  studyId: string;
  startedFrom: string;
  startedTo: string;
  actions?: TableActionItem[];
  showStudyFilter?: boolean;
  onQualityStatusesChange: (statuses: InterviewQualityFilter[]) => void;
  onStudyIdChange: (value: string) => void;
  onStartedFromChange: (value: string) => void;
  onStartedToChange: (value: string) => void;
}

export function ProjectInterviewsFilters({
  qualityStatuses,
  studyId,
  startedFrom,
  startedTo,
  actions = [],
  showStudyFilter = false,
  onQualityStatusesChange,
  onStudyIdChange,
  onStartedFromChange,
  onStartedToChange,
}: ProjectInterviewsFiltersProps) {
  const [qualityOpen, setQualityOpen] = useState(false);
  return (
    <div className="flex flex-wrap items-end gap-3 border-b border-neutral-200 bg-neutral-50 px-5 py-4">
      <StatusMultiSelect
        label="Quality status"
        options={QUALITY_STATUS_OPTIONS}
        selectedStatuses={qualityStatuses}
        onStatusesChange={onQualityStatusesChange}
        open={qualityOpen}
        onOpenChange={setQualityOpen}
      />

      {showStudyFilter && (
        <UuidFilterInput
          label="Study"
          value={studyId}
          onChange={onStudyIdChange}
          placeholder="Study UUID"
          className="flex min-w-[260px] flex-col gap-1 text-small font-medium text-neutral-700"
        />
      )}

      <label className="flex min-w-[160px] flex-col gap-1 text-small font-medium text-neutral-700">
        Interview from
        <input
          type="date"
          value={startedFrom}
          onChange={(event) => onStartedFromChange(event.target.value)}
          className="h-10 rounded-lg border border-neutral-200 bg-white px-3 text-body text-neutral-900"
        />
      </label>

      <label className="flex min-w-[160px] flex-col gap-1 text-small font-medium text-neutral-700">
        Interview to
        <input
          type="date"
          value={startedTo}
          onChange={(event) => onStartedToChange(event.target.value)}
          className="h-10 rounded-lg border border-neutral-200 bg-white px-3 text-body text-neutral-900"
        />
      </label>

      {actions.length > 0 && (
        <div className="ml-auto flex min-w-[2.5rem] justify-end">
          <TableActionMenu actions={actions} label="Interview table actions" />
        </div>
      )}
    </div>
  );
}
